import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import {
  Accordion,
  Button,
  Column,
  Columns,
  Container,
} from '@resurs/midas-react'

import { getText } from '../../../../internal/TextLabels'

import BatchImportErrorUI from './BatchImportErrorUI'
import Page from '../../../../internal/Page'
import PageActionBar from '../../../../internal/PageActionBar'
import { sendAddMultipleUsersEvent } from '../../../../util/ga-helpers'
import {
  showImportErrors,
  showValidationErrors,
} from '../../../../store/actions/batch-import-actions'

const BatchImportUsersUI = props => {
  const [errors, setErrors] = useState(null)
  const doBatchImport = () => {
    props.batchImport(props.files).catch(error => {
      if (error.errors) {
        setErrors(showImportErrors(error))
      } else if (error.data) {
        setErrors(showValidationErrors(error.data))
      }
    })
  }

  return (
    <Container>
      <Columns>
        <Column col3 colXl2 colMd0 />
        <Column col6 colXl8 colMd12>
          <Page title={getText('user.import.title')}>
            <PageActionBar
              showPrev
              actions={
                <Button
                  text={getText('user.import.card.importButton')}
                  onClick={() => {
                    sendAddMultipleUsersEvent('Complete')
                    doBatchImport()
                  }}
                  loading={props.fileIsLoading}
                  type="primary"
                  size="small"
                  kind="success"
                  disabled={props.files.length <= 0}
                />
              }
            />
            <Container>
              <Columns>
                <Column col12>
                  <BatchImportErrorUI errors={errors} />
                  <p>{getText('user.import.card.title')}</p>
                  <Dropzone
                    className="dropzone"
                    accept=".csv"
                    style={{
                      display: 'flex',
                      flex: '1 1 100%',
                      minHeight: '200px',
                      alignItems: 'center',
                      alignSelf: 'center',
                      justifyContent: 'center',
                      border: '1px dashed',
                      borderRadius: '2px',
                      cursor: 'pointer',
                    }}
                    onDrop={files => {
                      setErrors(null)
                      props.onDrop(files)
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '10px',
                        marginTop: '2rem',
                        marginBottom: '1rem',
                      }}
                    >
                      <i
                        style={
                          props.files.length > 0
                            ? {
                                color: 'green',
                              }
                            : null
                        }
                        className={`${midas.icon} ${midas[props.icon]} ${
                          midas.largeIcon
                        }`}
                      />
                      {props.files.length === 0 &&
                        !props.uploadFailed &&
                        !props.wrongFileFormat && (
                          <div>{getText('user.import.card.dropZone')}</div>
                        )}
                      {props.files.length === 0 &&
                        props.wrongFileFormat &&
                        !props.uploadFailed && (
                          <div>
                            {getText('user.import.card.wrongFileFormat')}
                          </div>
                        )}
                      {props.files.length === 0 && props.uploadFailed && (
                        <div className={`${midas.pt10} ${midas.pb10}`}>
                          {getText('user.import.card.uploadFailed')}
                        </div>
                      )}
                      {props.files.length > 0 && (
                        <div className={`${midas.pt10} ${midas.pb10}`}>
                          <div>{`'${props.files[0].name}' är tillagd.`}</div>
                        </div>
                      )}
                    </div>
                  </Dropzone>
                  {props.batchTemplateUrl && (
                    <div>
                      <p>
                        {getText('user.import.card.csvFileInfo')}
                        <a
                          style={{
                            paddingLeft: '2px',
                          }}
                          href={props.batchTemplateUrl}
                          onClick={() =>
                            sendAddMultipleUsersEvent('Download Template')
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                          download
                        >
                          {getText('user.import.card.downloadLink')}
                        </a>
                      </p>
                    </div>
                  )}
                  <Accordion
                    values={[
                      {
                        key: 1,
                        value: getText('user.import.card.whatIsCsv'),
                        items: [
                          {
                            key: 1,
                            value: getText('user.import.card.whatIsCsvMore'),
                          },
                        ],
                      },
                    ]}
                  />
                  <p>{getText('user.import.card.csvExcel')}</p>
                  <NavLink
                    to="/support/faq#humany-merchant-portal-inline=/2721/skapa-csv-fil-fran-excel-mall"
                    onClick={() => sendAddMultipleUsersEvent('Read our guide')}
                  >
                    {getText('user.import.card.guideCsv')}
                  </NavLink>
                </Column>
              </Columns>
            </Container>
          </Page>
        </Column>
      </Columns>
    </Container>
  )
}

BatchImportUsersUI.propTypes = {
  files: PropTypes.array.isRequired,
  icon: PropTypes.string.isRequired,
  wrongFileFormat: PropTypes.bool.isRequired,
  uploadFailed: PropTypes.bool.isRequired,
  onDrop: PropTypes.func.isRequired,
  batchImport: PropTypes.func.isRequired,
  fileIsLoading: PropTypes.bool.isRequired,
  batchTemplateUrl: PropTypes.string,
}

BatchImportUsersUI.defaultProps = {
  batchTemplateUrl: null,
}

export default BatchImportUsersUI
